import React from 'react';

import styles from './pressMediaReorderFormStyles';

import Link from 'buyside/components/presentation/Link/link';
import ReorderForm from 'buyside/components/presentation/Form/ReorderForm/reorderForm';

import { truncateText } from 'buyside/util/textHelpers';
import { formatDate } from 'buyside/util/dateHelper';

const MAX_TITLE_LENGTH = 60;

const renderPress = press => {
  const title = truncateText(press.title, MAX_TITLE_LENGTH);
  return (
    <div className={styles.press}>
      <Link to="#">{title}</Link>
      <span>{formatDate(press.publishDate)}</span>
    </div>
  );
};

const PressMediaReorderForm = ({ modalId }) => {
  return <ReorderForm modalId={modalId} attr="fundProfile.presses" renderItem={renderPress} />;
};

export default PressMediaReorderForm;
